import React from 'react';
import { motion } from 'framer-motion';
import { UnlockIcon, ClockIcon, HeadphonesIcon } from 'lucide-react';
// Custom Shield SVG
const ShieldIcon = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-231">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-232" />
    <path d="m9 12 2 2 4-4" data-id="element-233" />
  </svg>;
export function GarantiaSection() {
  return <section className="py-24 bg-brand-darker relative border-t border-white/5 overflow-hidden" data-id="element-234">
      {/* Green glow background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-96 bg-brand-green/10 blur-[150px] rounded-full pointer-events-none" data-id="element-235" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-236">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl mx-auto text-center" data-id="element-237">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-brand-black border border-brand-green/30 mb-8 shadow-[0_0_40px_rgba(16,185,129,0.2)]" data-id="element-238">
            <ShieldIcon className="w-12 h-12 text-brand-green" data-id="element-239" />
          </div>

          <h2 className="font-heading text-4xl md:text-6xl font-bold text-white mb-8" data-id="element-240">
            Garantía Doctor Ecommerce
          </h2>

          <p className="text-xl md:text-2xl text-brand-gray leading-relaxed mb-16 font-light" data-id="element-241">
            Si en los primeros 30 días no ves un aumento real en llamadas y
            leads de calidad,{' '}
            <span className="text-brand-green font-semibold" data-id="element-242">
              trabajamos gratis
            </span>{' '}
            hasta que lo consigas. Sin contratos largos. Sin letra pequeña. Solo
            resultados.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto" data-id="element-243">
            <div className="flex items-center justify-center space-x-3 bg-brand-black/50 border border-white/10 py-4 px-6 rounded-lg backdrop-blur-sm" data-id="element-244">
              <UnlockIcon className="w-5 h-5 text-brand-yellow" data-id="element-245" />
              <span className="text-sm font-medium text-white uppercase tracking-wide" data-id="element-246">
                Sin Contratos Largos
              </span>
            </div>
            <div className="flex items-center justify-center space-x-3 bg-brand-black/50 border border-white/10 py-4 px-6 rounded-lg backdrop-blur-sm" data-id="element-247">
              <ClockIcon className="w-5 h-5 text-brand-yellow" data-id="element-248" />
              <span className="text-sm font-medium text-white uppercase tracking-wide" data-id="element-249">
                Resultados en 48-72 Horas
              </span>
            </div>
            <div className="flex items-center justify-center space-x-3 bg-brand-black/50 border border-white/10 py-4 px-6 rounded-lg backdrop-blur-sm" data-id="element-250">
              <HeadphonesIcon className="w-5 h-5 text-brand-yellow" data-id="element-251" />
              <span className="text-sm font-medium text-white uppercase tracking-wide" data-id="element-252">
                Soporte 24/7 en Español
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}